export function isVideoUrl(url) {
  if (!url || typeof url !== 'string') return false
  const path = url.split('?')[0].toLowerCase()
  return /\.(mp4|webm|ogg|mov|m4v)(?:$|\/)/.test(path) || /\/video\//i.test(path)
}

/** OSS 图片压缩；视频 URL 原样返回 */
export function formatImg(url) {
  if (!url) return ''
  if (isVideoUrl(url)) return url
  if (url.includes('x-oss-process')) return url
  return url + '?x-oss-process=image/resize,w_1920/format,webp/quality,q_80'
}
